var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCardBlueDoc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M484.5 73.5h-457A27.54 27.54 0 0 0 0 101v310a27.54 27.54 0 0 0 27.5 27.5h457A27.54 27.54 0 0 0 512 411V101a27.54 27.54 0 0 0-27.5-27.5ZM497 411a12.52 12.52 0 0 1-12.5 12.5h-457A12.52 12.52 0 0 1 15 411V101a12.52 12.52 0 0 1 12.5-12.5h457A12.52 12.52 0 0 1 497 101Z",
    fill: "#45586b",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.5 323.5h-100A17.52 17.52 0 0 0 337 341v40a17.52 17.52 0 0 0 17.5 17.5h100A17.52 17.52 0 0 0 472 381v-40a17.52 17.52 0 0 0-17.5-17.5ZM457 381a2.5 2.5 0 0 1-2.5 2.5h-100a2.5 2.5 0 0 1-2.5-2.5v-40a2.5 2.5 0 0 1 2.5-2.5h100a2.5 2.5 0 0 1 2.5 2.5ZM197.5 113.5h-140A17.52 17.52 0 0 0 40 131v180a17.52 17.52 0 0 0 17.5 17.5h140A17.52 17.52 0 0 0 215 311V131a17.52 17.52 0 0 0-17.5-17.5ZM200 311a2.5 2.5 0 0 1-2.5 2.5h-140A2.5 2.5 0 0 1 55 311v-10a72.26 72.26 0 0 1 40.41-65 47.41 47.41 0 0 0 64.18 0A72.26 72.26 0 0 1 200 301Zm-72.5-77.5A32.5 32.5 0 1 1 160 201a32.54 32.54 0 0 1-32.5 32.5Zm41.55-9.5A47.5 47.5 0 1 0 86 224a87.23 87.23 0 0 0-31 27.92V131a2.5 2.5 0 0 1 2.5-2.5h140a2.5 2.5 0 0 1 2.5 2.5v120.92A87.23 87.23 0 0 0 169.05 224ZM207.5 383.5H91.25a7.5 7.5 0 0 0 0 15H207.5a7.5 7.5 0 0 0 0-15ZM53.25 383.5H47.5a7.5 7.5 0 0 0 0 15h5.75a7.5 7.5 0 0 0 0-15ZM306.33 168.5H461a7.5 7.5 0 0 0 0-15H306.33a7.5 7.5 0 0 0 0 15ZM261 168.5h8a7.5 7.5 0 0 0 0-15h-8a7.5 7.5 0 0 0 0 15ZM261 218.5h200a7.5 7.5 0 0 0 0-15H261a7.5 7.5 0 0 0 0 15ZM468.5 261a7.5 7.5 0 0 0-7.5-7.5H261a7.5 7.5 0 0 0 0 15h200a7.5 7.5 0 0 0 7.5-7.5Z",
    fill: "#45586b",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardBlueDoc2);
export default __webpack_public_path__ + "static/media/id-card-blue-doc-2.baaf86966c32df00fa287508ae31ef76.svg";
export { ForwardRef as ReactComponent };